<app-score-dashboard
    class="h-auto overflow-visible"
    [title]="'Tags Required'"
    [trendingTitle]="'My Score Trending'"
    [centerText]="'My Score'"
    [showScore]="true"
    [showTrending]="true"
    [showBreakdownCharts]="false"
    [loadScoreData]="loadScoreData"
    [loadTrendingData]="loadTrendingData"
    [exportData]="exportData"
    [formatMode]="'percent'"
    [palette]="palette"
    [useCapitalCaseFormatting]="false"
    [containerClass]="'px-4 pb-4'">
</app-score-dashboard>
